import {WordType} from "@/types/words";

export const SCRYFALL_SEARCHABLE_CATEGORIES = [
  'card',
  'type',
  'set',
  'keyword',
  'artist',
  'tag',
  'cost',
  'text',
]

export const scryfallSearchFromWord = (word: WordType): string => {
  const scryfallBaseUrl = 'https://scryfall.com/search?q=order:edhrec '
  if (word.category === 'card') {
    return scryfallBaseUrl + `name:/\\b${word.word}\\b/`
  }
  if (word.category === 'set') {
    return scryfallBaseUrl + `set:${word.word}`
  }
  if (word.category === 'type') {
    return scryfallBaseUrl + `t:${word.word}`
  }
  if (word.category === 'keyword') {
    return scryfallBaseUrl + `keyword:${word.word}`
  }
  if (word.category === 'artist') {
    return scryfallBaseUrl + `a:${word.word}`
  }
  if (word.category === 'tag') {
    return scryfallBaseUrl + `function:${word.word} or art:${word.word}`
  }
  if (word.category === 'cost') {
    return scryfallBaseUrl + `mana:${word.word}`
  }
  if (word.category === 'text') {
    return scryfallBaseUrl + `o:"${word.word}"`
  }
  return scryfallBaseUrl
}

export const googleSearchFromWord = (word: WordType): string => {
  return `https://www.google.com/search?q=magic the gathering ${word.word}`
}